import { getUrl } from '../config';
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Outlet, useLocation } from "react-router-dom";
import axios from 'axios';

import { Box, CssBaseline, Paper as MuiPaper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { spacing } from "@mui/system";

import GlobalStyle from "../components/GlobalStyle";
import Navbar from "../components/navbar/Navbar";
import dashboardItems from "../components/sidebar/dashboardItems";
import dashboardItems2 from "../components/sidebar/dashboardItemsOther";
import Sidebar from "../components/sidebar/Sidebar";
import Footer from "../components/Footer";

const drawerWidth = 258;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

const Dashboard = ({ children }) => {
  const router = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [user, setUser] = React.useState([]);
  const [loadingUser, setLoadingUser] = useState(true);  // Ajout de l'état loadingUser

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setMobileOpen(false);
  }, [router.pathname]);

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  const fetchUser = async () => {
    try {
      const response = await axios.get(getUrl() + `/api/user/getMe`);
      if (response.data.status === 'success') {
        setUser(response.data.user);
      } else {
        console.error('Erreur lors de la récupération des Users: ', response.data.message);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des Users :", error);
    } finally {
      setLoadingUser(false); // Une fois les données récupérées, on arrête le loading
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      {!open && !loadingUser && (  // On n'affiche la sidebar que si les données sont chargées
        <Drawer>
          <Box sx={{ display: { xs: "block", lg: "none" } }}>
            <Sidebar
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              items={user.country === -1 ? null : (user.country === 2 || user.country === 3 ? dashboardItems2 : dashboardItems)}
            />
          </Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Sidebar
              PaperProps={{ style: { width: drawerWidth } }}
              items={user.country === -1 ? null : (user.country === 2 || user.country === 3 ? dashboardItems2 : dashboardItems)}
            />
          </Box>
        </Drawer>
      )}
      <AppContent>
        <Navbar onDrawerToggle={handleDrawerToggle} onOpenToggle={handleOpen} />
        <MainContent p={isLgUp ? 12 : 5}>
          {children}
          <Outlet />
        </MainContent>
        <Footer />
      </AppContent>
    </Root>
  );
};

export default Dashboard;